<template>
  <div style="min-height: calc(100vh - 158px);" class="card">
    <div style="background: #DBE7F2" class="p-2">
      <TitleButton
          btnTitle="Add New"
          :showBtn="false"
          :showSettingBtn="false"
          :showAddNew="true"
          title="Activity List"
          @onClickAddNewButton="onClickAddNewButton"
          @onClickSettingButton="onClickSettingButton"
      />
      <div class="row">
        <div class="col-10">
          <label for="colFormLabel" class="col-form-label">Search</label>
          <input class="form-control" type="text" name="status" v-model="quick_search">
        </div>
        <div class="col-2">
          <label for="">&nbsp;</label>
          <button
              style="min-width: 64px;margin-top: 1rem;"
              @click="onClickSearchButton"
              class="btn btn-primary waves-effect waves-float waves-light form-control"
          >Go
          </button>
        </div>
      </div>
    </div>

    <div class="col-12 mt-2">
      <div class="d-flex justify-content-end px-2">
        <button
            @click="exportTable"
            class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
        >
          Export
        </button>
      </div>
    </div>
    <ListTable
        :activities="activityList"
        @onEdit="onEditActivity"
    />
    <div class="mb-2"></div>
    <div class="px-2 position-absolute bottom-0">
      <Pagination
          :offset="offset"
          @onPageChange="onPageChange"
          ref="pagination"
      />
    </div>

    <ActivityAddModal
        modalTitle="Add Activity"
        :showParent="true"
        ref="program"
        :formData="activity"
        @onSubmitForm="handleActivitySubmit"
        @onCloseActivityModal="resetForm"
    />
  </div>
</template>

<script>
import TitleButton from '@/components/atom/TitleButton'
import ListTable
  from '@/components/molecule/procurement/organization-settings/admin-setup/activity/ActivityListingTable'
import ActivityAddModal
  from '@/components/molecule/procurement/organization-settings/admin-setup/activity/ActivityAddModal'

import Pagination from '@/components/atom/Pagination'
import Loader from '@/components/atom/LoaderComponent'
import handleActivities from "@/services/modules/procurement/organization-settings/activity";
import {inject} from "vue";

export default {
  name: 'ProgramList',

  components: {
    TitleButton,
    ListTable,
    ActivityAddModal,
    Pagination,
    Loader,
  },

  data: () => ({
    loading: false,
    quick_search: null,
    offset: 20,
    activityList: [],
    activity: {
      name: '',
      short_name: '',
      code: null,
      description: null,
    },
  }),

  computed: {
    companyId() {
      return this.$route.params.companyId
    },
  },

  methods: {
    onClickAddNewButton() {
      this.$refs.program.toggleModal()
    },

    onClickSettingButton() {
      alert('Setting Button clicked');
    },

    onClickSearchButton() {
      alert('Search Button clicked');
    },

    resetForm() {
      this.activity = {
        name: '',
        short_name: null,
        code: null,
        description: null,
      }
    },

    async handleActivitySubmit() {
      this.loading = true

      this.activity.company_id = this.$route.params.companyId;
      this.activity.user_id = this.$store.getters["user/getUser"].id;
      this.activity.updated_by = this.$store.getters["user/getUser"].id;

      try {
        let res = null;

        if (this.activity.id) {
          res = await this.updateActivity(this.activity.id, this.activity);
        } else {
          res = await this.createNewActivity(this.activity);
        }

        if (!res.status) {
          this.showError(res.message);
        } else {
          this.showSuccess(res.message);
          this.resetForm();
          this.onClickAddNewButton();
          await this.getActivities();
        }
      } catch (err) {
        if (!err.response) {
          this.showError('Something is wrong. Check your connectivity!!')
        } else if (err.response) {
          this.showError(err.response.message)
        }
      } finally {
        this.loading = false;
      }
    },

    async getActivities() {
      const query = this.getQuery();
      try {
        this.loading = true;
        let res = await this.fetchActivityList(query);
        if (!res.status) {
          this.resetPagination();
        } else if (res.status) {
          this.activityList = res.data;
        }
      } catch (err) {
        if (err.response) {
          this.showError(err.response.message)
        }
      } finally {
        this.loading = false
      }
    },

    getQuery() {
      let query = '?company_id=' + this.companyId
      query += '&offset=' + this.offset
      if (this.page) query += '&page=' + this.page
      return query
    },

    onPageChange(page) {
      let routeQuery = Object.assign({}, this.$route.query)
      routeQuery.page = page
      this.$router.push({path: this.$route.path, query: routeQuery})
      setTimeout(() => {
        this.getActivities();
      }, 100)
    },

    onEditActivity(data) {
      this.activity = data;
      this.onClickAddNewButton();
    },

    exportTable() {
      //todo
    },
  },

  setup() {
    const showError = inject('showError');
    const showSuccess = inject('showSuccess');

    const {
      loading,
      fetchActivityList,
      createNewActivity,
      updateActivity,
    } = handleActivities();

    return {
      showError,
      showSuccess,
      loading,
      fetchActivityList,
      createNewActivity,
      updateActivity,
    }
  },

  mounted() {
    this.getActivities();
  }
}
</script>
